<template>
    <TermsOfUse/>
</template>

<script>
    import TermsOfUse from "./TermsOfUse";
    export default {
        name: "Main",
      components: {TermsOfUse},
      created() {
        this.$store.commit("SET_PAGE_TYPE", "termsOfUse");
        this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%)");
        // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
      }
    }
</script>

<style scoped>

</style>
